import React, { RefObject, useState } from 'react';

import { useWindowSize } from '../../../../hooks/use-window-size';

import Hamburger from '../../../../assets/svg/hamburger2.svg';
import Close from '../../../../assets/svg/close.svg';
import AvionautLogo from '@assets/svg/avionaut-black.svg';

import ProductNavigation from '../../../../app/product/components/product-navigation/ProductNavigation.component';
import MobileMenu from './components/MobileMenu.components';

import { getLink } from '@helpers/linking.helper';
import { PageType } from '@constants/pageType.constants';

import { useIntl } from 'gatsby-plugin-intl';

import s from './MobileNavigation.module.scss';


interface IMobileNavigation {
  refWrapper: RefObject<HTMLDivElement>;
  refProductNavigation: RefObject<HTMLDivElement>;
  multilingualSlugsForStaticPages: any;
  multilingualSlugsForCmsArticle: any;
  isProductSite?: boolean;
}

const MobileNavigation = (props: IMobileNavigation) => {
  const {
    refWrapper,
    refProductNavigation,
    multilingualSlugsForStaticPages,
    multilingualSlugsForCmsArticle,
    isProductSite,
  } = props;

  const intl = useIntl();

  const windowSize = useWindowSize();

  const [isMenuOpen, setIsMenuDisplay] = useState<boolean>(false);

  const handleMobileMenu = () => {
    setIsMenuDisplay(!isMenuOpen);
  };

  return (
    <>
      <div className={`${s.mobileNavigation__wrapper} ${isMenuOpen ? s.visible : ''}`}>
        <div
          className={`${s.mobileNavigation} ${isMenuOpen ? '' : s.lowerNavigation}`}
          ref={isMenuOpen ? undefined : refWrapper}>
          {
            windowSize.width && <>
              <div className={s.mobileNavigation__signet}>
                <a href={getLink(intl.locale, PageType.START)}
                   onClick={() => {
                     setIsMenuDisplay(false);
                   }
                   }>
                  <AvionautLogo className={s.mobileNavigation__signetSvg}/>
                </a>
              </div>
              <div className={s.mobileNavigation__icon}>
                <div className={s.mobileNavigation__hamburger} onClick={() => handleMobileMenu()}>
                  {isMenuOpen ? <Close className={s.mobileNavigation__closeSvg} onClick={() => {
                    setIsMenuDisplay(false);
                  }} /> :
                    <div className={s.mobileNavigation__menu}>
                      <span >
                        Menu
                      </span>
                      <Hamburger className={s.mobileNavigation__hamburgerSvg}/>
                    </div>
                  }
                </div>
              </div>
            </>
          }
        </div>
        {/*{isProductSite && <div*/}
        {/*  className={`${s.mobileNavigation__productNavigation} ${s.lowerProductNavigation}`}>*/}
        {/*  <ProductNavigation*/}
        {/*    refProductNavigation={refProductNavigation}*/}
        {/*  />*/}
        {/*</div>}*/}
        {isMenuOpen &&
          <MobileMenu
            setIsMenuDisplay={setIsMenuDisplay}
            multilingualSlugsForStaticPages={multilingualSlugsForStaticPages}
            multilingualSlugsForCmsArticle={multilingualSlugsForCmsArticle}
          />
        }
      </div>
    </>
  );
};

export default MobileNavigation;
